module.exports = __webpack_public_path__ + "img/home-bj.c56eb54e.png";